module.exports = "/static/assets/241ad769cabf379fde4d1bf64aa06a8a.png";